import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

const StatsVideo = () => (
  <StaticQuery
    query={graphql`
      {
        allContentfulNational {
          edges {
            node {
              title
              publishDate
              statsembedd {
                childMarkdownRemark {
                  html
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html:
              data.allContentfulNational.edges[0].node.statsembedd
                .childMarkdownRemark.html,
          }}
        />
      </div>
    )}
  ></StaticQuery>
)

export default StatsVideo
